import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import Select from 'react-select';
import { isMobile } from 'react-device-detect';
import DailyPerfCumRow from './DailyPerfCumRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  loadFundDetailsPortfolio,
  setPerfEndDate,
  setPerfStartDate,
} from '../../../actions';
import i18n from '../../../i18n';
import './DailyPerformance.css';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import isEqual from 'lodash/isEqual';

const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 0,
    boxShadow: 'none',
  }),
  option: (provided) => ({
    ...provided,
    color: '#5b6770',
    fontSize: 14,
    borderRadius: 0,
    backgroundColor: 'white',
    ':hover': {
      backgroundColor: '#050139',
      color: 'white',
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 100ms';
    return { ...provided, opacity, transition };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: '#050139',
  }),

};

class DailyPerformance extends Component {

  constructor(props) {
    super(props);

    const {
      data,
    } = props;

    function getQtr(month) {
      if (month <= 3) {
        return 1;
      } else if (month <= 6) {
        return 4;
      } else if (month <= 9) {
        return 7;
      } else {
        return 10;
      }
    }

    const startDate = new Date(data[0].levelsDaily.date[0]);
    const endDate = new Date(data[0].levelsDaily.date[data[0].levelsDaily.date.length - 1]);
    const startDateActual = new Date(startDate);
    startDateActual.setDate(startDateActual.getDate());
    const chartOptions = chartData(data, startDate, endDate, 'ror');
    this.state = {
      origDate: `${(startDate.getMonth() + 1)}/${(startDate.getDate())}/${startDate.getFullYear()}`,
      startDate: `${(startDateActual.getMonth() + 1)}/${(startDateActual.getDate())}/${startDateActual.getFullYear()}`,
      startDateOriginal: `${(startDateActual.getMonth() + 1)}/${(startDateActual.getDate())}/${startDateActual.getFullYear()}`,
      startDateDisplay: `${(startDateActual.getMonth() + 1)}/${(startDateActual.getDate())}/${startDateActual.getFullYear()}`,
      endDate: `${(endDate.getMonth() + 1)}/${(endDate.getDate())}/${endDate.getFullYear()}`,
      endDateOriginal: `${(endDate.getMonth() + 1)}/${(endDate.getDate())}/${endDate.getFullYear()}`,
      endDateDisplay: `${(endDate.getMonth() + 1)}/${(endDate.getDate())}/${endDate.getFullYear()}`,
      mtdDate: `${(endDate.getMonth() + 1)}/1/${endDate.getFullYear()}`,
      qtdDate: `${getQtr(endDate.getMonth() + 1)}/1/${endDate.getFullYear()}`,
      ytdDate: `1/1/${endDate.getFullYear()}`,
      oneYDate: `${(endDate.getMonth() + 1)}/${(endDate.getDate())}/${endDate.getFullYear() - 1}`,
      threeYDate: `${(endDate.getMonth() + 1)}/${(endDate.getDate())}/${endDate.getFullYear() - 3}`,
      fiveYDate: `${(endDate.getMonth() + 1)}/${(endDate.getDate())}/${endDate.getFullYear() - 5}`,
      tenYDate: `${(endDate.getMonth() + 1)}/${(endDate.getDate())}/${endDate.getFullYear() - 10}`,
      chartType: { value: 'ror', label: 'Cumulative Total Return' },
      chartOptions: chartOptions,
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.data, this.props.data)) {
      const chartOptions = chartData(this.props.data, this.state.startDate, this.state.endDate, this.state.chartType.value);
      this.setState({ chartOptions });
    }
  }

  componentWillMount() {
    const {
      perfStartDate,
    } = this.props;

    if (perfStartDate) {
      this.setState({ startDateDisplay: perfStartDate });
      this.resetStartDate(perfStartDate);
    } else {
      this.props.setPerfStartDate(this.state.startDate);
    }

    this.props.setPerfEndDate(this.state.endDate);
  }

  resetStartDate(dateStr) {
    const {
      chartType,
      endDate,
    } = this.state;
    const {
      data,
    } = this.props;
    this.setState({ startDate: dateStr });
    this.setState({ endDateDisplay: endDate });
    this.setState({ chartOptions: chartData(data, dateStr, endDate, chartType.value) });
  }

  onStartInputChange = (event) => {
    const m = event.target.value;
    this.setState({ startDateDisplay: m });
  };

  onStartFormSubmit = (event) => {
    event.preventDefault();
    const dateStr = this.state.startDateDisplay;
    const newDate = new Date(dateStr);
    if (isNaN(newDate.getTime())) {
      this.setState({ startDateDisplay: this.state.startDate });
    } else {
      this.resetStartDate(dateStr);
      this.props.setPerfStartDate(dateStr);
    }
  };

  onEndInputChange = (event) => {
    const m = event.target.value;
    this.setState({ endDateDisplay: m });
  };

  onEndFormSubmit = (event) => {
    event.preventDefault();
    const dateStr = this.state.endDateDisplay;
    const newDate = new Date(dateStr);
    if (isNaN(newDate.getTime())) {
      this.setState({ endDateDisplay: this.state.endDate });
    } else {
      this.setState({ endDate: dateStr });
      this.props.setPerfEndDate(dateStr);
      // this.props.loadFundDetailsPortfolio(true, dateStr)
    }
  };

  onGoFormSubmit = () => {
    const { data } = this.props;  
    const { chartType, startDateOriginal, endDateOriginal, startDateDisplay, endDateDisplay } = this.state;      

    const newStartDate = getNextBusinessDay(new Date(startDateDisplay),startDateOriginal);
    const newEndDate = getNextBusinessDay(new Date(endDateDisplay),endDateOriginal);

    const startDateChange = this.state.startDate !== startDateDisplay;
    const endDateChange = this.state.endDate !== endDateDisplay;

    const startDateFinal = newStartDate < new Date(startDateOriginal) ? new Date(startDateOriginal) : newStartDate;
    const endDateFinal = newEndDate > new Date(endDateOriginal) ? new Date(endDateOriginal) :  newEndDate;

    const startDateDisplayFinal = newStartDate < new Date(startDateOriginal) ? startDateOriginal : startDateDisplay;
    const endDateDisplayFinal = newEndDate > new Date(endDateOriginal) ? endDateOriginal :  endDateDisplay;

    if (startDateChange) {
      this.props.setPerfStartDate(startDateDisplay);
    }

    if (endDateChange) {
      this.props.setPerfEndDate(endDateDisplay);
    }

    this.setState({ 
      startDate: startDateFinal,
      endDate: endDateFinal,
      startDateDisplay: startDateDisplayFinal,
      endDateDisplay: endDateDisplayFinal,
      chartOptions: chartData(data, startDateFinal, endDateFinal, chartType.value)
    });      
};

  handleChartTypeChange = (chartType) => {
    const {
      startDate,
      endDate,
    } = this.state;
    const {
      data,
    } = this.props;
    this.setState({ chartOptions: chartData(data, startDate, endDate, chartType.value) });
    this.setState({ chartType: chartType });
  };

  setDate = async (theDate) => {
    let newDate = null;
    if (theDate === 'mtd') {
      newDate = this.state.mtdDate;
    } else if (theDate === 'qtd') {
      newDate = this.state.qtdDate;
    } else if (theDate === 'ytd') {
      newDate = this.state.ytdDate;
    } else if (theDate === '1y') {
      newDate = this.state.oneYDate;
    } else if (theDate === '3y') {
      newDate = this.state.threeYDate;
    } else if (theDate === '5y') {
      newDate = this.state.fiveYDate;
    } else if (theDate === '10y') {
      newDate = this.state.tenYDate;
    } else if (theDate === 'max') {
      newDate = this.state.origDate;
    }

    newDate = new Date(newDate);

    newDate.setDate(newDate.getDate());
    await this.setState( {endDate: this.state.endDateOriginal })
    await this.setState({ startDateDisplay: `${(newDate.getMonth() + 1)}/${(newDate.getDate())}/${newDate.getFullYear()}` });
    await this.resetStartDate(`${(newDate.getMonth() + 1)}/${(newDate.getDate())}/${newDate.getFullYear()}`);
    await this.props.setPerfStartDate(`${(newDate.getMonth() + 1)}/${(newDate.getDate())}/${newDate.getFullYear()}`);
  }

  handleDatazoomChange = (data) => {
    const {
      chartOptions,
    } = this.state;
    const startIdx = Math.floor(chartOptions.xAxis.data.length * (data.start * .01));
    const endIdx = Math.floor(chartOptions.xAxis.data.length * (data.end * .01));
    if (chartOptions.xAxis.data[startIdx]) {
      this.setState({ startDateDisplay: chartOptions.xAxis.data[startIdx] });
    }
    if (chartOptions.xAxis.data[endIdx]) {
      this.setState({ endDateDisplay: chartOptions.xAxis.data[endIdx] });
    }
  };

  renderHeader() {
    const {
      startDateDisplay,
      endDateDisplay,
    } = this.state;

    return (
      <thead>
        <tr>
          <th colSpan="5" className='textLeft'>PERFORMANCE {i18n.t('from')} {startDateDisplay} to {endDateDisplay} </th>

        </tr>
        <tr>
          <th scope="col" className='textLeft'>{i18n.t('Ticker')}</th>
          <th scope="col" className='textLeft'>{i18n.t('Fund')}</th>
          <th scope='col' className='textCenter'>{i18n.t('Inception')}<br /> {i18n.t('Date')}</th>
          <th colSpan="col" className='borderleft borderbottom textCenter'>{i18n.t('Cumulative Returns')}</th>
          <th colSpan="col" className='borderleft borderbottom textCenter'>{i18n.t('Average Annual Total Returns')}</th>
        </tr>
      </thead>
    );
  }

  renderRows() {
    const { startDateDisplay, endDateDisplay, } = this.state;
    const chartDataFiltered = this.state.chartOptions.series;

    const startDateD = new Date(startDateDisplay);
    const endDateD = new Date(endDateDisplay);

    const timeDiff = Math.abs(endDateD.getTime() - startDateD.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));


    return chartDataFiltered.map((fund) => {
      if (!fund?.fundType) {
        return null
      }
      return (
        <DailyPerfCumRow key={fund.name} fund={fund} diffDays={diffDays} fundType={fund.fundType} ms={fund.msUrl} url={fund.fundPageURL} />
      );
    });
  }

  render() {
    const {
      origDate,
      startDateDisplay,
      endDateDisplay,
      chartType,
      oneYDate,
      threeYDate,
      fiveYDate,
      tenYDate,
      chartOptions,
    } = this.state;

    return (
      <div>
        <div className='chartHeader'>{i18n.t('Daily NAV Performance')}</div>
        {/* <div className={s.heading} style={{ lineHeight: '14px', marginBottom: '13px' }}>{i18n.t('Daily NAV Performance')}</div> */}
        <div className='row' style={{ marginBottom: '20px' }}>
          <div className='col-md-3' style={{ textAlign: 'center', paddingRight: '3px' }}>
            <Select
              options={[
                { value: 'ror', label: 'Cumulative Total Return' },
                { value: 'growth10k', label: 'Growth of 10K' },
              ]}
              styles={customStyles}
              value={chartType}
              onChange={(value) => this.handleChartTypeChange(value)}
            />
          </div>
          <div className='col-md-6' style={{ textAlign: 'center', paddingLeft: '3px', paddingRight: '3px' }}>
            <button className='dlyPerfbutton' onClick={() => this.setDate('mtd')}>MTD</button>
            <button className='dlyPerfbutton' onClick={() => this.setDate('qtd')}>QTD</button>
            <button className='dlyPerfbutton' onClick={() => this.setDate('ytd')}>YTD</button>
            {new Date(origDate) <= new Date(oneYDate) &&
              <button className='dlyPerfbutton' onClick={() => this.setDate('1y')}>1Y</button>
            }
            {new Date(origDate) <= new Date(threeYDate) &&
              <button className='dlyPerfbutton' onClick={() => this.setDate('3y')}>3Y</button>
            }
            {new Date(origDate) <= new Date(fiveYDate) &&
              <button className='dlyPerfbutton' onClick={() => this.setDate('5y')}>5Y</button>
            }
            {new Date(origDate) <= new Date(tenYDate) &&
              <button className='dlyPerfbutton' onClick={() => this.setDate('10y')}>10Y</button>
            }
            <button className='dlyPerfbutton' style={{ borderRight: '1px solid #CCC' }} onClick={() => this.setDate('max')}>MAX</button>
          </div>
          <div className='col-md-3' style={{ textAlign: 'right', paddingLeft: '0px' }}>
            <div style={{ display: 'inline-block', verticalAlign: 'top', width: '90px', textAlign: 'right', paddingLeft: '3px' }}>
              <form onSubmit={this.onStartFormSubmit}>
                <input
                  name='startDate'
                  style={{ textAlign: 'center', paddingLeft: '5px', paddingRight: '5px', height: '38px', borderRadius: '0px' }}
                  className='form-control'
                  onChange={this.onStartInputChange}
                  value={startDateDisplay}
                />
              </form>
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top', width: '20px', textAlign: 'center', lineHeight: '38px', color: '#5b6770', fontSize: '14px' }}>
              to
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top', width: '90px', textAlign: 'right' }}>
              <form onSubmit={this.onEndFormSubmit}>
                <input
                  name='endDate'
                  style={{ textAlign: 'center', paddingLeft: '5px', paddingRight: '5px', height: '38px', borderRadius: '0px' }}
                  className='form-control'
                  onChange={this.onEndInputChange}
                  value={endDateDisplay}
                />
              </form>
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top', paddingLeft: '5px' }}>
            </div>            
            <button className='dlyPerfGoButton' onClick={() => this.onGoFormSubmit('go')}>
              {this.props.loadingPerformance ? <FontAwesomeIcon icon={faSpinner} spin /> : 'GO' }
            </button>
          </div>
        </div>
        <div className='chartContainer'>
          <ReactEcharts
            option={chartOptions}
            theme='default'
            style={{ height: 500 }}
            onEvents={{ 'datazoom': this.handleDatazoomChange }}
          />
        </div>
        <div className='table-responsive'>
          <table className='table tableFC'>
            {this.renderHeader()}
            <tbody>{this.renderRows()}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

function getNextBusinessDay(date, originalDate) {
  if (isNaN(Date.parse(date))) {
    return originalDate;
  }

  let nextDay = new Date(date);
  let day = nextDay.getDay();

  // If it's Saturday (5), add two days
  if (day === 6) {
      nextDay.setDate(nextDay.getDate() + 2);
  }
  // If it's Sunday (0), add one day
  else if (day === 0) {
      nextDay.setDate(nextDay.getDate() + 1);
  }
  return nextDay;
}

function getLegendData(data) {
  return data.map((fund) => {
    return (
      fund.ticker
    );
  });
}

function getXData(data) {
  return data[0].levelsDaily.date.map((value) => {
    const date = new Date(value);
    return (
      `${(date.getMonth() + 1)}/${(date.getDate())}/${date.getFullYear()}`
    );
  });
}

function cumSum(data) {
  const cumulativeSum = (sum => value => sum += (sum * value))(1);
  const cums = data.map(cumulativeSum);
  return cums.map((data) => (data - 1) * 100);
}

function growth10k(data) {
  const growth = (sum => value => sum += (sum * value))(10000);
  return data.map(growth);
}

function getLookupDate(seriesDate, fund) {
  let inputDate = new Date(seriesDate);
  inputDate.setUTCHours(16, 0, 0, 0);
  let isoDate = inputDate.toISOString();
  let lookupDate = isoDate.slice(0, isoDate.indexOf('.')) + 'Z';
  let theIndex = fund.levelsDaily.date?.indexOf(lookupDate);
  
  let counter = 0;
  while (theIndex === -1 && counter < 6) {
    inputDate.setDate(inputDate.getDate() + 1);
    isoDate = inputDate.toISOString();
    lookupDate = isoDate.slice(0, isoDate.indexOf('.')) + 'Z';
    theIndex = fund.levelsDaily.date?.indexOf(lookupDate);
    counter++;
  }

  counter = 0;
  while (theIndex === -1 && counter < 6) {
    inputDate.setDate(inputDate.getDate() - 2); // subtract 2 because we added 1 in the previous loop
    isoDate = inputDate.toISOString();
    lookupDate = isoDate.slice(0, isoDate.indexOf('.')) + 'Z';
    theIndex = fund.levelsDaily.date?.indexOf(lookupDate);
    counter++;
  }

  return theIndex;
}


function getSeriesData(data, startDate, endDate, chartType) {
  return data.map((fund) => {
    const data = {
      name: fund.ticker,
      fullName: fund.name,
      exchangeCode: fund.exchangeCode,
      fundType: fund.type,
      inceptionDate: fund.inceptionDate,
      fundPageURL: fund.fundPageURL,
      type: 'line',
      smooth: true,
      symbol: 'none',
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2,
          },
        },
      },
    };

    // let startIndex = fund.levelsDaily.date.indexOf(lookupDate);
    let startIndex = getLookupDate(getNextBusinessDay(startDate, startDate), fund); 
    let endIndex = getLookupDate(getNextBusinessDay(endDate, endDate), fund); 

    // const endIndex = 10000
    const days = startIndex - endIndex
    const levels = fund?.levelsDaily?.dlyRoR?.slice(startIndex, endIndex+1);

    if (!levels) {
      return null
    }

    levels[0] = 0.0;

    if (chartType === 'growth10k') {
      data.data = growth10k(levels);
    } else if (chartType === 'ror') {
      data.data = cumSum(levels);
    }
    data.cumSum = cumSum(levels);
    return data;
  });

}

function dataFormatter(value, type) {
  if (type === 'growth10k') {
    return `$${Math.trunc(value).toLocaleString('en-US')}`;
  } else {
    return `${value.toFixed(2)}%`;
  }
}

function chartData(data, startDate, endDate, chartType) {
  const chartColors = ['#0047BB', '#050139', '#8C959B', '#F68D2E', '#65BD18', '#00A9E0'];
  const legendData = getLegendData(data);
  let xaxisData = getXData(data);

  startDate = new Date(startDate);
  endDate = new Date(endDate);

  xaxisData = xaxisData.filter((item) => {
    let itemDate = new Date(item);
    return itemDate > startDate && itemDate <= endDate;
  });
  
  xaxisData.unshift(`${(startDate.getMonth() + 1)}/${(startDate.getDate())}/${startDate.getFullYear()}`);
  const seriesData = getSeriesData(data, startDate, endDate, chartType);

  // create the chart option with data
  const widthPct = isMobile ? '15%' : '10%';

  return {
    title: {
      text: '',
      left: 5,
      textStyle: {
        fontStyle: 'normal',
        fontWeight: 900,
        fontSize: 14,
        color: '#8C959B',
      },
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name;
        for (let i = 0, l = params.length; i < l; i++) {
          if (!params[i].value) {
            continue;
          }
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${dataFormatter(params[i].value, chartType)}`;
        }
        return res;
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left',
      },
    },
    legend: {
      itemGap: 20,
      data: legendData,
    },
    grid: {
      top: '10%',
      left: widthPct,
      right: widthPct,
      bottom: '15%',
    },
    dataZoom: [{
      type: 'inside',
      start: 0,
      end: 100,
    }, {
      type: 'slider',
      start: 0,
      end: 100,
      handleSize: '100%',
      handleStyle: {
        color: '#050139',
      },
      showDetail: false,
    }],
    xAxis: {
      type: 'category',
      axisLabel: {
        fontSize: 12,
        color: '#8C959B',
        rotate: 0,
      },
      data: xaxisData,
    },
    yAxis: {
      type: 'value',
      min: 'dataMin',
      axisLabel: {
        fontSize: 12,
        color: '#8C959B',
        formatter: function (value) {
          return dataFormatter(value, chartType);
        },
      },
    },
    series: seriesData,
    color: chartColors,
  };
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    perfStartDate: state.params.perfStartDate,
    wtRegion: state.params.wtRegion,
    loadingPerformance: state.fundData.loadingPerformance,
  };
}

export default connect(mapStateToProps, {
  loadFundDetailsPortfolio,
  setPerfEndDate,
  setPerfStartDate,
})(DailyPerformance);


